import { render, staticRenderFns } from "./EditCotejos.vue?vue&type=template&id=de16b856"
import script from "./EditCotejos.vue?vue&type=script&lang=js"
export * from "./EditCotejos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de16b856')) {
      api.createRecord('de16b856', component.options)
    } else {
      api.reload('de16b856', component.options)
    }
    module.hot.accept("./EditCotejos.vue?vue&type=template&id=de16b856", function () {
      api.rerender('de16b856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/tasks/EditCotejos.vue"
export default component.exports